import React from 'react';

interface EditorToastBubbleProps {
  message: string | null;
}

/**
 * 画面下中央に表示する toast 通知 (例: 「位置を調整しました」)。
 * message が null/'' のときは何も描画しない。
 * FingeringEditorPage から issue #17 Phase 2 で抽出。
 */
const EditorToastBubble: React.FC<EditorToastBubbleProps> = ({ message }) => {
  if (!message) return null;
  return (
    <div
      data-testid="editor-toast"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-slate-800/95 backdrop-blur-sm text-slate-200 px-5 py-2.5 rounded-xl text-[13px] font-medium shadow-xl shadow-black/40 border border-slate-700/60 z-50 animate-fade-in-up"
    >
      {message}
    </div>
  );
};

export default EditorToastBubble;
